import React from 'react';
import { AuthProvider } from 'react-oidc-context';
import {
    HashRouter,
    Route, Switch,
} from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '../redux/configureStore';
import App from './App';

const CALLBACK_PATH = '/login/callback';

const clientId = process.env.REACT_APP_OKTA_CLIENT_ID || '5ose1rmamn739hi706lgqqdoi0';
const issuer = process.env.REACT_APP_OKTA_ISSUER || 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_yYVR17kuI';

const oidcConfig = {
    authority: issuer,
    client_id: clientId,
    redirect_uri: `${window.location.origin}/login/callback`,
    scope: 'openid email',
    onSigninCallback: () => {
        window.location.href = '/';
    },
};

export default function Security() {
    return (
        <Provider store={store}>
            <AuthProvider {...oidcConfig}>
                <HashRouter>
                    <App />
                </HashRouter>
            </AuthProvider>
        </Provider>
    );
}
